// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file releases/v1/releases.proto (package releases.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file releases/v1/releases.proto.
 */
export const file_releases_v1_releases: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * NotifyReleaseRequest is sent by x-forge-installer when a new build is
 * available.  The endpoint is idempotent: re-notifying the same
 * version+repository pair returns the existing record with created=false.
 *
 * @generated from message releases.v1.NotifyReleaseRequest
 */
export type NotifyReleaseRequest = Message<"releases.v1.NotifyReleaseRequest"> & {
  /**
   * Semantic version string (e.g. "1.09")
   *
   * @generated from field: string version = 1;
   */
  version: string;

  /**
   * Git branch that produced this build
   *
   * @generated from field: string branch = 2;
   */
  branch: string;

  /**
   * Full Git commit SHA
   *
   * @generated from field: string commit_sha = 3;
   */
  commitSha: string;

  /**
   * GitHub repository in owner/repo form (e.g. "uniphore/x-forge")
   *
   * @generated from field: string repository = 4;
   */
  repository: string;

  /**
   * GitHub actor or service account that triggered the build
   *
   * @generated from field: string triggered_by = 5;
   */
  triggeredBy: string;

  /**
   * Application group for future segregation (e.g. "baic", "marketing-ai-cloud")
   *
   * @generated from field: string release_group = 6;
   */
  releaseGroup: string;

  /**
   * Optional JSON string of the release manifest (xforge-db + microservices[],
   * matching x-forge-installer's baic-releases/<version>.json shape). Empty
   * string is valid for callers that don't have manifest data on hand.
   * Stored verbatim into releases.manifest_metadata on insert. Unlike
   * SyncRelease (which also flips sync_status/last_synced_at), this does not
   * mark the release as explicitly synced - PromoteRelease's freshness gate
   * still requires a SyncRelease before promoting.
   *
   * @generated from field: string metadata = 7;
   */
  metadata: string;
};

/**
 * Describes the message releases.v1.NotifyReleaseRequest.
 * Use `create(NotifyReleaseRequestSchema)` to create a new message.
 */
export const NotifyReleaseRequestSchema: GenMessage<NotifyReleaseRequest> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 0);

/**
 * NotifyReleaseResponse acknowledges the release notification.
 *
 * @generated from message releases.v1.NotifyReleaseResponse
 */
export type NotifyReleaseResponse = Message<"releases.v1.NotifyReleaseResponse"> & {
  /**
   * Typed ID of the persisted release record (rel_[20])
   *
   * @generated from field: string release_id = 1;
   */
  releaseId: string;

  /**
   * true when this call created a new record; false when returning an existing one
   *
   * @generated from field: bool created = 2;
   */
  created: boolean;
};

/**
 * Describes the message releases.v1.NotifyReleaseResponse.
 * Use `create(NotifyReleaseResponseSchema)` to create a new message.
 */
export const NotifyReleaseResponseSchema: GenMessage<NotifyReleaseResponse> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 1);

/**
 * RegisterWorkflowRunRequest is sent by x-forge-installer when a GitHub
 * Actions workflow run starts so Sunstone can correlate it with a deployment.
 *
 * @generated from message releases.v1.RegisterWorkflowRunRequest
 */
export type RegisterWorkflowRunRequest = Message<"releases.v1.RegisterWorkflowRunRequest"> & {
  /**
   * Typed deployment ID (deploy_[20])
   *
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;

  /**
   * Typed workspace ID (workspace_[20]); empty for bootstrap-kind runs
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;

  /**
   * Typed tenant ID (tenant_[20])
   *
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * Workflow kind: "bootstrap", "workspace", or "release". "release" runs
   * have no workspace_id/deployment_id/tenant_id (a release-level sync isn't
   * owned by any one workspace or deployment) - release_id is required instead.
   *
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * GitHub Actions run ID (numeric, stored as string)
   *
   * @generated from field: string run_id = 5;
   */
  runId: string;

  /**
   * Direct URL to the GitHub Actions run page
   *
   * @generated from field: string run_url = 6;
   */
  runUrl: string;

  /**
   * Workflow file path (e.g. ".github/workflows/deploy.yml")
   *
   * @generated from field: string workflow = 7;
   */
  workflow: string;

  /**
   * GitHub Environment name (e.g. "sunstone-my-deployment")
   *
   * @generated from field: string environment = 8;
   */
  environment: string;

  /**
   * Git ref that triggered the run (e.g. "refs/heads/main")
   *
   * @generated from field: string ref = 9;
   */
  ref: string;

  /**
   * Optional release ID to associate with this run (rel_[20])
   *
   * @generated from field: string release_id = 10;
   */
  releaseId: string;

  /**
   * Human-readable description of what this run will do
   *
   * @generated from field: string description = 11;
   */
  description: string;

  /**
   * Temporal workflow ID to signal when this run registers and completes.
   * The Temporal workflow uses this to unblock WaitForWorkflowRunActivity.
   *
   * @generated from field: string temporal_workflow_id = 12;
   */
  temporalWorkflowId: string;
};

/**
 * Describes the message releases.v1.RegisterWorkflowRunRequest.
 * Use `create(RegisterWorkflowRunRequestSchema)` to create a new message.
 */
export const RegisterWorkflowRunRequestSchema: GenMessage<RegisterWorkflowRunRequest> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 2);

/**
 * RegisterWorkflowRunResponse acknowledges the run registration.
 *
 * @generated from message releases.v1.RegisterWorkflowRunResponse
 */
export type RegisterWorkflowRunResponse = Message<"releases.v1.RegisterWorkflowRunResponse"> & {
  /**
   * Typed ID of the persisted workflow run record (wrun_[20])
   *
   * @generated from field: string workflow_run_id = 1;
   */
  workflowRunId: string;

  /**
   * true when a new record was created; false when returning an existing one
   *
   * @generated from field: bool created = 2;
   */
  created: boolean;

  /**
   * Typed release ID associated with this run (rel_[20]); may be empty
   * when no release is associated.
   *
   * @generated from field: string release_id = 3;
   */
  releaseId: string;
};

/**
 * Describes the message releases.v1.RegisterWorkflowRunResponse.
 * Use `create(RegisterWorkflowRunResponseSchema)` to create a new message.
 */
export const RegisterWorkflowRunResponseSchema: GenMessage<RegisterWorkflowRunResponse> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 3);

/**
 * WorkflowLogRequest appends a structured log line to a workflow run.
 * Failures are non-fatal on the server: the caller should proceed even if
 * this RPC returns an error.
 *
 * @generated from message releases.v1.WorkflowLogRequest
 */
export type WorkflowLogRequest = Message<"releases.v1.WorkflowLogRequest"> & {
  /**
   * Typed workflow run ID (wrun_[20])
   *
   * @generated from field: string workflow_run_id = 1;
   */
  workflowRunId: string;

  /**
   * Log message
   *
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * Severity level: "debug", "info", "warn", or "error"
   *
   * @generated from field: string severity = 3;
   */
  severity: string;

  /**
   * Log timestamp as Unix milliseconds; 0 means use server time
   *
   * @generated from field: int64 timestamp_ms = 4;
   */
  timestampMs: bigint;

  /**
   * JSON string containing all job conclusions for this run.
   * Populated only on the final WorkflowLog call from notify-sunstone.
   * Shape: {"jobs":[{"name":"...","conclusion":"..."},...]}
   *
   * @generated from field: string job_conclusions = 5;
   */
  jobConclusions: string;
};

/**
 * Describes the message releases.v1.WorkflowLogRequest.
 * Use `create(WorkflowLogRequestSchema)` to create a new message.
 */
export const WorkflowLogRequestSchema: GenMessage<WorkflowLogRequest> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 4);

/**
 * WorkflowLogResponse is empty — the caller should ignore errors from WorkflowLog.
 *
 * @generated from message releases.v1.WorkflowLogResponse
 */
export type WorkflowLogResponse = Message<"releases.v1.WorkflowLogResponse"> & {
};

/**
 * Describes the message releases.v1.WorkflowLogResponse.
 * Use `create(WorkflowLogResponseSchema)` to create a new message.
 */
export const WorkflowLogResponseSchema: GenMessage<WorkflowLogResponse> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 5);

/**
 * WorkflowCompleteRequest is sent by x-forge-installer when a workflow run
 * reaches a terminal state.
 *
 * @generated from message releases.v1.WorkflowCompleteRequest
 */
export type WorkflowCompleteRequest = Message<"releases.v1.WorkflowCompleteRequest"> & {
  /**
   * Typed workflow run ID (wrun_[20])
   *
   * @generated from field: string workflow_run_id = 1;
   */
  workflowRunId: string;

  /**
   * Terminal conclusion: "success", "failure", "cancelled", or "skipped"
   *
   * @generated from field: string conclusion = 2;
   */
  conclusion: string;

  /**
   * Human-readable description of the outcome
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * Completion timestamp as Unix milliseconds; 0 means use server time
   *
   * @generated from field: int64 completed_at_ms = 4;
   */
  completedAtMs: bigint;

  /**
   * Temporal workflow ID — required when workflow_run_id is absent (i.e.
   * RegisterWorkflowRun failed in x-forge-installer) so Temporal can still
   * be signalled directly.
   *
   * @generated from field: string temporal_workflow_id = 5;
   */
  temporalWorkflowId: string;

  /**
   * Name of the first GitHub Actions job that failed; empty on success.
   *
   * @generated from field: string failed_job = 6;
   */
  failedJob: string;

  /**
   * Name of the first step within failed_job that failed; empty on success.
   *
   * @generated from field: string failed_step = 7;
   */
  failedStep: string;

  /**
   * Last ~30 lines of failed_step's log; empty on success.
   *
   * @generated from field: string error_tail = 8;
   */
  errorTail: string;

  /**
   * Workflow identifier sent by x-forge-installer (e.g. "new_installation").
   *
   * @generated from field: string workflow = 9;
   */
  workflow: string;

  /**
   * X-Forge UI URL for this workspace; populated only on workspace workflows on success.
   *
   * @generated from field: string forge_ui_url = 10;
   */
  forgeUiUrl: string;

  /**
   * DuploCloud portal URL for this deployment; populated only on deployment workflows on success.
   *
   * @generated from field: string duplo_portal_url = 11;
   */
  duploPortalUrl: string;
};

/**
 * Describes the message releases.v1.WorkflowCompleteRequest.
 * Use `create(WorkflowCompleteRequestSchema)` to create a new message.
 */
export const WorkflowCompleteRequestSchema: GenMessage<WorkflowCompleteRequest> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 6);

/**
 * WorkflowCompleteResponse acknowledges the completion notification.
 *
 * @generated from message releases.v1.WorkflowCompleteResponse
 */
export type WorkflowCompleteResponse = Message<"releases.v1.WorkflowCompleteResponse"> & {
};

/**
 * Describes the message releases.v1.WorkflowCompleteResponse.
 * Use `create(WorkflowCompleteResponseSchema)` to create a new message.
 */
export const WorkflowCompleteResponseSchema: GenMessage<WorkflowCompleteResponse> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 7);

/**
 * StreamReleaseEventsRequest is sent by the UI to subscribe to release
 * announcements.  The stream stays open until the client disconnects.
 *
 * @generated from message releases.v1.StreamReleaseEventsRequest
 */
export type StreamReleaseEventsRequest = Message<"releases.v1.StreamReleaseEventsRequest"> & {
};

/**
 * Describes the message releases.v1.StreamReleaseEventsRequest.
 * Use `create(StreamReleaseEventsRequestSchema)` to create a new message.
 */
export const StreamReleaseEventsRequestSchema: GenMessage<StreamReleaseEventsRequest> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 8);

/**
 * StreamReleaseEventsResponse is one event pushed to the UI.
 * The payload is a JSON object matching the pg_notify message shape:
 *   { "event_type": "release.notified", "release_id": "rel_...",
 *     "version": "1.09", "repository": "uniphore/x-forge",
 *     "release_group": "baic", "triggered_by": "ci-bot",
 *     "received_at": "2026-04-22T10:00:00Z" }
 *   { "event_type": "release.audit_event", "release_id": "rel_...",
 *     "audit_id": "...", "timestamp_ms": ... }
 *   { "event_type": "keepalive" }
 *
 * @generated from message releases.v1.StreamReleaseEventsResponse
 */
export type StreamReleaseEventsResponse = Message<"releases.v1.StreamReleaseEventsResponse"> & {
  /**
   * Raw JSON payload from pg_notify — decoded by the client.
   *
   * @generated from field: string payload = 1;
   */
  payload: string;
};

/**
 * Describes the message releases.v1.StreamReleaseEventsResponse.
 * Use `create(StreamReleaseEventsResponseSchema)` to create a new message.
 */
export const StreamReleaseEventsResponseSchema: GenMessage<StreamReleaseEventsResponse> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 9);

/**
 * StreamWorkflowRunEventsRequest subscribes to log and status events for a
 * workflow run identified by its deterministic Temporal workflow ID (e.g.
 * release-plan-<workspace_id>) — not the GitHub-assigned wrun_id, which may
 * not exist yet at subscribe time. The stream closes when the run reaches a
 * terminal state (WorkflowComplete is received) or the client disconnects.
 *
 * @generated from message releases.v1.StreamWorkflowRunEventsRequest
 */
export type StreamWorkflowRunEventsRequest = Message<"releases.v1.StreamWorkflowRunEventsRequest"> & {
  /**
   * Deterministic Temporal workflow ID to subscribe to.
   *
   * @generated from field: string temporal_workflow_id = 1;
   */
  temporalWorkflowId: string;

  /**
   * Unix milliseconds from RunReleasePlanResponse.dispatched_at_ms. Since a
   * temporal_workflow_id is reused across every dispatch for the same
   * workspace (Temporal allows starting a new execution once the prior one
   * closes), a workflow_runs row matching this ID from BEFORE since_ms
   * belongs to a prior, unrelated run and must be treated as "not found yet"
   * rather than replayed. 0 means no cutoff (accept whatever is found).
   *
   * @generated from field: int64 since_ms = 2;
   */
  sinceMs: bigint;
};

/**
 * Describes the message releases.v1.StreamWorkflowRunEventsRequest.
 * Use `create(StreamWorkflowRunEventsRequestSchema)` to create a new message.
 */
export const StreamWorkflowRunEventsRequestSchema: GenMessage<StreamWorkflowRunEventsRequest> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 10);

/**
 * EmitWorkflowEventRequest is sent by x-forge-installer to record a
 * structured infra event (e.g. terraform_started, resource_created).
 *
 * @generated from message releases.v1.EmitWorkflowEventRequest
 */
export type EmitWorkflowEventRequest = Message<"releases.v1.EmitWorkflowEventRequest"> & {
  /**
   * Typed workflow run ID (wrun_[20])
   *
   * @generated from field: string workflow_run_id = 1;
   */
  workflowRunId: string;

  /**
   * event_type maps to an audit event constant e.g. infra.terraform_started
   *
   * @generated from field: string event_type = 2;
   */
  eventType: string;

  /**
   * params is a JSON string of structured event data
   *
   * @generated from field: string params = 3;
   */
  params: string;

  /**
   * timestamp as Unix milliseconds; 0 means use server time
   *
   * @generated from field: int64 timestamp_ms = 4;
   */
  timestampMs: bigint;

  /**
   * deployment_id is forwarded for authentication context
   *
   * @generated from field: string deployment_id = 5;
   */
  deploymentId: string;
};

/**
 * Describes the message releases.v1.EmitWorkflowEventRequest.
 * Use `create(EmitWorkflowEventRequestSchema)` to create a new message.
 */
export const EmitWorkflowEventRequestSchema: GenMessage<EmitWorkflowEventRequest> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 11);

/**
 * EmitWorkflowEventResponse acknowledges the event.
 *
 * @generated from message releases.v1.EmitWorkflowEventResponse
 */
export type EmitWorkflowEventResponse = Message<"releases.v1.EmitWorkflowEventResponse"> & {
};

/**
 * Describes the message releases.v1.EmitWorkflowEventResponse.
 * Use `create(EmitWorkflowEventResponseSchema)` to create a new message.
 */
export const EmitWorkflowEventResponseSchema: GenMessage<EmitWorkflowEventResponse> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 12);

/**
 * StreamWorkflowRunEventsResponse is one event pushed to the UI for a run.
 *
 * @generated from message releases.v1.StreamWorkflowRunEventsResponse
 */
export type StreamWorkflowRunEventsResponse = Message<"releases.v1.StreamWorkflowRunEventsResponse"> & {
  /**
   * event_type distinguishes log lines from status changes.
   * Values: "log" | "completed"
   *
   * @generated from field: string event_type = 1;
   */
  eventType: string;

  /**
   * severity is set for event_type="log": debug | info | warn | error
   *
   * @generated from field: string severity = 2;
   */
  severity: string;

  /**
   * message is the log text for event_type="log", or conclusion for "completed"
   *
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * timestamp_ms is Unix milliseconds of the event
   *
   * @generated from field: int64 timestamp_ms = 4;
   */
  timestampMs: bigint;
};

/**
 * Describes the message releases.v1.StreamWorkflowRunEventsResponse.
 * Use `create(StreamWorkflowRunEventsResponseSchema)` to create a new message.
 */
export const StreamWorkflowRunEventsResponseSchema: GenMessage<StreamWorkflowRunEventsResponse> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 13);

/**
 * Release is a persisted release build record.
 *
 * @generated from message releases.v1.Release
 */
export type Release = Message<"releases.v1.Release"> & {
  /**
   * Typed ID of the release record (rel_[20])
   *
   * @generated from field: string release_id = 1;
   */
  releaseId: string;

  /**
   * Semantic version string (e.g. "1.09")
   *
   * @generated from field: string version = 2;
   */
  version: string;

  /**
   * Git branch that produced this build
   *
   * @generated from field: string branch = 3;
   */
  branch: string;

  /**
   * Full Git commit SHA
   *
   * @generated from field: string commit_sha = 4;
   */
  commitSha: string;

  /**
   * GitHub repository in owner/repo form (e.g. "uniphore/x-forge")
   *
   * @generated from field: string repository = 5;
   */
  repository: string;

  /**
   * GitHub actor or service account that triggered the build
   *
   * @generated from field: string triggered_by = 6;
   */
  triggeredBy: string;

  /**
   * Application group (e.g. "baic", "marketing-ai-cloud")
   *
   * @generated from field: string release_group = 7;
   */
  releaseGroup: string;

  /**
   * When the release record was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * When the release notification was received
   *
   * @generated from field: google.protobuf.Timestamp received_at = 9;
   */
  receivedAt?: Timestamp;

  /**
   * Whether this release has been marked as deprecated by an operator
   *
   * @generated from field: bool is_deprecated = 10;
   */
  isDeprecated: boolean;

  /**
   * Computed server-side on every read; never settable directly. True when
   * this release may be selected for a new install or upgrade in the
   * *current* Sunstone environment (development/staging/production), per
   * environment-specific rules layered on top of is_deprecated.
   *
   * @generated from field: bool deployable = 13;
   */
  deployable: boolean;

  /**
   * Computed server-side on every read; never settable directly. True when
   * this is the highest-version deployable release within its release_group.
   *
   * @generated from field: bool is_latest = 14;
   */
  isLatest: boolean;

  /**
   * Result of the most recent explicit release-level manifest sync. Tracks
   * only whether SyncRelease's dispatched workflow has completed - not
   * whether manifest_metadata has any data. NotifyRelease may also seed
   * manifest_metadata (from its optional metadata field) without flipping
   * this out of NONE; only an explicit SyncRelease marks it SUCCEEDED.
   *
   * @generated from field: releases.v1.ReleaseSyncStatus sync_status = 15;
   */
  syncStatus: ReleaseSyncStatus;

  /**
   * When manifest_metadata was last refreshed by a successful sync. Unset if
   * sync_status is NONE.
   *
   * @generated from field: google.protobuf.Timestamp last_synced_at = 16;
   */
  lastSyncedAt?: Timestamp;

  /**
   * Error detail from the most recent failed sync. Empty on SUCCEEDED/NONE.
   *
   * @generated from field: string sync_error = 17;
   */
  syncError: string;

  /**
   * Whether this release is enabled for selection. Set via UpdateReleaseState
   * (operator_admin only). Disabled releases are hidden from workspace
   * create/upgrade dropdowns but remain visible in the admin release list.
   *
   * @generated from field: bool is_enabled = 18;
   */
  isEnabled: boolean;

  /**
   * Number of non-tombstoned workspaces currently on this exact release
   * (current_release_id). Only populated by ListReleases (the admin release
   * table); every other RPC returning a Release leaves this 0.
   *
   * @generated from field: int32 workspace_count = 19;
   */
  workspaceCount: number;
};

/**
 * Describes the message releases.v1.Release.
 * Use `create(ReleaseSchema)` to create a new message.
 */
export const ReleaseSchema: GenMessage<Release> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 14);

/**
 * SyncReleaseRequest triggers a release-level manifest sync: dispatches
 * weekly_release_sync.yml against the release's own branch and, on
 * completion, refreshes releases.manifest_metadata/sync_status/
 * last_synced_at. Fire-and-forget - returns immediately with sync_status
 * IN_PROGRESS; the caller polls GetReleaseByID/ListReleases (or subscribes to
 * StreamReleaseEvents) for the terminal status.
 *
 * @generated from message releases.v1.SyncReleaseRequest
 */
export type SyncReleaseRequest = Message<"releases.v1.SyncReleaseRequest"> & {
  /**
   * Typed ID of the release to sync (rel_[20])
   *
   * @generated from field: string release_id = 1;
   */
  releaseId: string;
};

/**
 * Describes the message releases.v1.SyncReleaseRequest.
 * Use `create(SyncReleaseRequestSchema)` to create a new message.
 */
export const SyncReleaseRequestSchema: GenMessage<SyncReleaseRequest> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 15);

/**
 * SyncReleaseResponse acknowledges the sync dispatch. Does not carry
 * sync_run_id - the RPC returns before x-forge-installer has registered a
 * run; read it off the Release row once populated instead.
 *
 * @generated from message releases.v1.SyncReleaseResponse
 */
export type SyncReleaseResponse = Message<"releases.v1.SyncReleaseResponse"> & {
  /**
   * @generated from field: releases.v1.ReleaseSyncStatus sync_status = 1;
   */
  syncStatus: ReleaseSyncStatus;
};

/**
 * Describes the message releases.v1.SyncReleaseResponse.
 * Use `create(SyncReleaseResponseSchema)` to create a new message.
 */
export const SyncReleaseResponseSchema: GenMessage<SyncReleaseResponse> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 16);

/**
 * DeprecateReleaseRequest marks a release as deprecated.
 *
 * @generated from message releases.v1.DeprecateReleaseRequest
 */
export type DeprecateReleaseRequest = Message<"releases.v1.DeprecateReleaseRequest"> & {
  /**
   * Typed ID of the release to deprecate (rel_[20])
   *
   * @generated from field: string release_id = 1;
   */
  releaseId: string;
};

/**
 * Describes the message releases.v1.DeprecateReleaseRequest.
 * Use `create(DeprecateReleaseRequestSchema)` to create a new message.
 */
export const DeprecateReleaseRequestSchema: GenMessage<DeprecateReleaseRequest> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 17);

/**
 * DeprecateReleaseResponse acknowledges the deprecation. Empty on success;
 * if the deprecation is blocked because one or more workspaces still depend
 * on this release, the RPC instead fails with a FAILED_PRECONDITION error -
 * see CheckReleaseDeprecateBlockers for the read-only, side-effect-free way
 * to check for blockers before calling this RPC.
 *
 * @generated from message releases.v1.DeprecateReleaseResponse
 */
export type DeprecateReleaseResponse = Message<"releases.v1.DeprecateReleaseResponse"> & {
};

/**
 * Describes the message releases.v1.DeprecateReleaseResponse.
 * Use `create(DeprecateReleaseResponseSchema)` to create a new message.
 */
export const DeprecateReleaseResponseSchema: GenMessage<DeprecateReleaseResponse> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 18);

/**
 * CheckReleaseDeprecateBlockersRequest checks whether a release can be
 * deprecated right now.
 *
 * @generated from message releases.v1.CheckReleaseDeprecateBlockersRequest
 */
export type CheckReleaseDeprecateBlockersRequest = Message<"releases.v1.CheckReleaseDeprecateBlockersRequest"> & {
  /**
   * Typed ID of the release to check (rel_[20])
   *
   * @generated from field: string release_id = 1;
   */
  releaseId: string;
};

/**
 * Describes the message releases.v1.CheckReleaseDeprecateBlockersRequest.
 * Use `create(CheckReleaseDeprecateBlockersRequestSchema)` to create a new message.
 */
export const CheckReleaseDeprecateBlockersRequestSchema: GenMessage<CheckReleaseDeprecateBlockersRequest> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 19);

/**
 * CheckReleaseDeprecateBlockersResponse reports how many workspaces
 * currently block deprecating this release - a workspace still has it as
 * current_release_id, or an in-flight promote/upgrade targets it as
 * target_release_id. A count of 0 means deprecation is allowed.
 *
 * @generated from message releases.v1.CheckReleaseDeprecateBlockersResponse
 */
export type CheckReleaseDeprecateBlockersResponse = Message<"releases.v1.CheckReleaseDeprecateBlockersResponse"> & {
  /**
   * @generated from field: int32 blocking_workspace_count = 1;
   */
  blockingWorkspaceCount: number;
};

/**
 * Describes the message releases.v1.CheckReleaseDeprecateBlockersResponse.
 * Use `create(CheckReleaseDeprecateBlockersResponseSchema)` to create a new message.
 */
export const CheckReleaseDeprecateBlockersResponseSchema: GenMessage<CheckReleaseDeprecateBlockersResponse> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 20);

/**
 * ListReleasesRequest lists persisted release records, optionally filtered by
 * application group, restricted to environment-deployable releases, and/or
 * searched by version/branch/repository.
 *
 * @generated from message releases.v1.ListReleasesRequest
 */
export type ListReleasesRequest = Message<"releases.v1.ListReleasesRequest"> & {
  /**
   * Optional: filter by application group (e.g. "baic").
   * Pass an empty string to return all releases.
   *
   * @generated from field: string release_group = 1;
   */
  releaseGroup: string;

  /**
   * When true, only releases that are `deployable` in the current Sunstone
   * environment are returned (drives the create-workspace dropdown). This
   * implies non-deprecated regardless of include_deprecated below.
   *
   * @generated from field: bool deployable_only = 2;
   */
  deployableOnly: boolean;

  /**
   * Maximum number of releases to return per page. Defaults to 50, capped at 200.
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;

  /**
   * 1-indexed page number. 0 or 1 means the first page.
   *
   * @generated from field: int32 page = 4;
   */
  page: number;

  /**
   * Optional free-text search, matched against version/branch/repository
   * (case-insensitive substring). Empty string returns all matching releases.
   *
   * @generated from field: string search = 5;
   */
  search: string;

  /**
   * When true, deprecated releases are included in the result (drives the
   * admin "view all releases" list). Default false preserves every existing
   * caller's behavior (deprecated releases excluded). Independent of
   * deployable_only - deployable_only=true always excludes deprecated
   * releases even if this is also true.
   *
   * @generated from field: bool include_deprecated = 6;
   */
  includeDeprecated: boolean;
};

/**
 * Describes the message releases.v1.ListReleasesRequest.
 * Use `create(ListReleasesRequestSchema)` to create a new message.
 */
export const ListReleasesRequestSchema: GenMessage<ListReleasesRequest> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 21);

/**
 * ListReleasesResponse contains the matching release records.
 *
 * @generated from message releases.v1.ListReleasesResponse
 */
export type ListReleasesResponse = Message<"releases.v1.ListReleasesResponse"> & {
  /**
   * Matching release records ordered by id DESC (newest first).
   *
   * @generated from field: repeated releases.v1.Release releases = 1;
   */
  releases: Release[];

  /**
   * Total number of matching releases across all pages (filtered by
   * release_group/deployable_only/search, ignoring page/page_size).
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message releases.v1.ListReleasesResponse.
 * Use `create(ListReleasesResponseSchema)` to create a new message.
 */
export const ListReleasesResponseSchema: GenMessage<ListReleasesResponse> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 22);

/**
 * GetLatestReleaseRequest fetches the newest non-deprecated release for a group.
 *
 * @generated from message releases.v1.GetLatestReleaseRequest
 */
export type GetLatestReleaseRequest = Message<"releases.v1.GetLatestReleaseRequest"> & {
  /**
   * Optional: filter by application group (e.g. "baic").
   *
   * @generated from field: string release_group = 1;
   */
  releaseGroup: string;
};

/**
 * Describes the message releases.v1.GetLatestReleaseRequest.
 * Use `create(GetLatestReleaseRequestSchema)` to create a new message.
 */
export const GetLatestReleaseRequestSchema: GenMessage<GetLatestReleaseRequest> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 23);

/**
 * GetLatestReleaseResponse returns the latest non-deprecated release.
 *
 * @generated from message releases.v1.GetLatestReleaseResponse
 */
export type GetLatestReleaseResponse = Message<"releases.v1.GetLatestReleaseResponse"> & {
  /**
   * @generated from field: releases.v1.Release release = 1;
   */
  release?: Release;
};

/**
 * Describes the message releases.v1.GetLatestReleaseResponse.
 * Use `create(GetLatestReleaseResponseSchema)` to create a new message.
 */
export const GetLatestReleaseResponseSchema: GenMessage<GetLatestReleaseResponse> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 24);

/**
 * GetReleaseByVersionRequest looks up a release by version string and group.
 *
 * @generated from message releases.v1.GetReleaseByVersionRequest
 */
export type GetReleaseByVersionRequest = Message<"releases.v1.GetReleaseByVersionRequest"> & {
  /**
   * Application group (e.g. "baic").
   *
   * @generated from field: string release_group = 1;
   */
  releaseGroup: string;

  /**
   * Semantic version string (e.g. "2.5.0").
   *
   * @generated from field: string version = 2;
   */
  version: string;
};

/**
 * Describes the message releases.v1.GetReleaseByVersionRequest.
 * Use `create(GetReleaseByVersionRequestSchema)` to create a new message.
 */
export const GetReleaseByVersionRequestSchema: GenMessage<GetReleaseByVersionRequest> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 25);

/**
 * GetReleaseByVersionResponse returns the matched release record.
 *
 * @generated from message releases.v1.GetReleaseByVersionResponse
 */
export type GetReleaseByVersionResponse = Message<"releases.v1.GetReleaseByVersionResponse"> & {
  /**
   * @generated from field: releases.v1.Release release = 1;
   */
  release?: Release;
};

/**
 * Describes the message releases.v1.GetReleaseByVersionResponse.
 * Use `create(GetReleaseByVersionResponseSchema)` to create a new message.
 */
export const GetReleaseByVersionResponseSchema: GenMessage<GetReleaseByVersionResponse> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 26);

/**
 * GetReleaseByIDRequest looks up a single release by its typed ID.
 *
 * @generated from message releases.v1.GetReleaseByIDRequest
 */
export type GetReleaseByIDRequest = Message<"releases.v1.GetReleaseByIDRequest"> & {
  /**
   * Typed release ID (rel_[20]).
   *
   * @generated from field: string release_id = 1;
   */
  releaseId: string;
};

/**
 * Describes the message releases.v1.GetReleaseByIDRequest.
 * Use `create(GetReleaseByIDRequestSchema)` to create a new message.
 */
export const GetReleaseByIDRequestSchema: GenMessage<GetReleaseByIDRequest> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 27);

/**
 * GetReleaseByIDResponse returns the matched release record.
 *
 * @generated from message releases.v1.GetReleaseByIDResponse
 */
export type GetReleaseByIDResponse = Message<"releases.v1.GetReleaseByIDResponse"> & {
  /**
   * @generated from field: releases.v1.Release release = 1;
   */
  release?: Release;
};

/**
 * Describes the message releases.v1.GetReleaseByIDResponse.
 * Use `create(GetReleaseByIDResponseSchema)` to create a new message.
 */
export const GetReleaseByIDResponseSchema: GenMessage<GetReleaseByIDResponse> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 28);

/**
 * UpdateReleaseStateRequest toggles a release's enabled/disabled state.
 *
 * @generated from message releases.v1.UpdateReleaseStateRequest
 */
export type UpdateReleaseStateRequest = Message<"releases.v1.UpdateReleaseStateRequest"> & {
  /**
   * Typed ID of the release to update (rel_[20])
   *
   * @generated from field: string release_id = 1;
   */
  releaseId: string;

  /**
   * New enabled state.
   *
   * @generated from field: bool is_enabled = 2;
   */
  isEnabled: boolean;
};

/**
 * Describes the message releases.v1.UpdateReleaseStateRequest.
 * Use `create(UpdateReleaseStateRequestSchema)` to create a new message.
 */
export const UpdateReleaseStateRequestSchema: GenMessage<UpdateReleaseStateRequest> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 29);

/**
 * UpdateReleaseStateResponse returns the updated release record.
 *
 * @generated from message releases.v1.UpdateReleaseStateResponse
 */
export type UpdateReleaseStateResponse = Message<"releases.v1.UpdateReleaseStateResponse"> & {
  /**
   * @generated from field: releases.v1.Release release = 1;
   */
  release?: Release;
};

/**
 * Describes the message releases.v1.UpdateReleaseStateResponse.
 * Use `create(UpdateReleaseStateResponseSchema)` to create a new message.
 */
export const UpdateReleaseStateResponseSchema: GenMessage<UpdateReleaseStateResponse> = /*@__PURE__*/
  messageDesc(file_releases_v1_releases, 30);

/**
 * ReleaseSyncStatus tracks the state of the release-level manifest sync
 * (SyncRelease + the releasesync.SyncReleaseWorkflow it dispatches). Distinct
 * from is_enabled/is_deprecated: this tracks whether releases.manifest_metadata
 * reflects a live fetch from the release's branch, not lifecycle state.
 *
 * @generated from enum releases.v1.ReleaseSyncStatus
 */
export enum ReleaseSyncStatus {
  /**
   * @generated from enum value: RELEASE_SYNC_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Default. Never synced - manifest_metadata is empty.
   *
   * @generated from enum value: RELEASE_SYNC_STATUS_NONE = 1;
   */
  NONE = 1,

  /**
   * SyncRelease has dispatched weekly_release_sync.yml and is awaiting completion.
   *
   * @generated from enum value: RELEASE_SYNC_STATUS_IN_PROGRESS = 2;
   */
  IN_PROGRESS = 2,

  /**
   * The most recent sync completed successfully; manifest_metadata is fresh
   * as of last_synced_at.
   *
   * @generated from enum value: RELEASE_SYNC_STATUS_SUCCEEDED = 3;
   */
  SUCCEEDED = 3,

  /**
   * The most recent sync failed; see sync_error.
   *
   * @generated from enum value: RELEASE_SYNC_STATUS_FAILED = 4;
   */
  FAILED = 4,
}

/**
 * Describes the enum releases.v1.ReleaseSyncStatus.
 */
export const ReleaseSyncStatusSchema: GenEnum<ReleaseSyncStatus> = /*@__PURE__*/
  enumDesc(file_releases_v1_releases, 0);

/**
 * ReleasesService handles notifications from x-forge-installer GitHub Actions
 * workflows.  All RPCs require a bearer token from SUNSTONE_RELEASE_NOTIFY_TOKEN.
 *
 * @generated from service releases.v1.ReleasesService
 */
export const ReleasesService: GenService<{
  /**
   * NotifyRelease persists a new release build and emits a Release Announcement UI event.
   * Idempotent: repeating the same version+repository returns the existing record.
   *
   * @generated from rpc releases.v1.ReleasesService.NotifyRelease
   */
  notifyRelease: {
    methodKind: "unary";
    input: typeof NotifyReleaseRequestSchema;
    output: typeof NotifyReleaseResponseSchema;
  },
  /**
   * RegisterWorkflowRun persists a GitHub Actions run record and signals the
   * associated Temporal workflow to begin polling for status changes.
   * Idempotent: repeating the same deployment_id+run_id returns the existing record.
   *
   * @generated from rpc releases.v1.ReleasesService.RegisterWorkflowRun
   */
  registerWorkflowRun: {
    methodKind: "unary";
    input: typeof RegisterWorkflowRunRequestSchema;
    output: typeof RegisterWorkflowRunResponseSchema;
  },
  /**
   * WorkflowLog appends a structured log line to a workflow run.
   * Non-fatal: server logs DB failures and returns 200 regardless.
   *
   * @generated from rpc releases.v1.ReleasesService.WorkflowLog
   */
  workflowLog: {
    methodKind: "unary";
    input: typeof WorkflowLogRequestSchema;
    output: typeof WorkflowLogResponseSchema;
  },
  /**
   * WorkflowComplete records the terminal status and signals Temporal to
   * unblock WaitForWorkflowRunActivity.
   *
   * @generated from rpc releases.v1.ReleasesService.WorkflowComplete
   */
  workflowComplete: {
    methodKind: "unary";
    input: typeof WorkflowCompleteRequestSchema;
    output: typeof WorkflowCompleteResponseSchema;
  },
  /**
   * EmitWorkflowEvent records a structured infra event from x-forge-installer
   * (e.g. terraform_started, resource_created) as a workspace-scoped audit event.
   *
   * @generated from rpc releases.v1.ReleasesService.EmitWorkflowEvent
   */
  emitWorkflowEvent: {
    methodKind: "unary";
    input: typeof EmitWorkflowEventRequestSchema;
    output: typeof EmitWorkflowEventResponseSchema;
  },
  /**
   * StreamReleaseEvents opens a server-sent stream of Release Announcement
   * events.  Requires Auth0 JWT (standard UI auth).  Stays open until the
   * client disconnects; there is no terminal event.
   *
   * @generated from rpc releases.v1.ReleasesService.StreamReleaseEvents
   */
  streamReleaseEvents: {
    methodKind: "server_streaming";
    input: typeof StreamReleaseEventsRequestSchema;
    output: typeof StreamReleaseEventsResponseSchema;
  },
  /**
   * StreamWorkflowRunEvents streams log lines and status changes for a single
   * workflow run.  Requires Auth0 JWT.  Closes when the run completes or the
   * client disconnects.
   *
   * @generated from rpc releases.v1.ReleasesService.StreamWorkflowRunEvents
   */
  streamWorkflowRunEvents: {
    methodKind: "server_streaming";
    input: typeof StreamWorkflowRunEventsRequestSchema;
    output: typeof StreamWorkflowRunEventsResponseSchema;
  },
  /**
   * ListReleases returns persisted release records, optionally filtered by
   * application group, restricted to deployable releases, and/or searched by
   * version/branch/repository. Paginated via page/page_size (offset-based,
   * matching WorkspaceService.ListWorkspaces).
   * Requires Auth0 JWT (standard UI auth).
   *
   * @generated from rpc releases.v1.ReleasesService.ListReleases
   */
  listReleases: {
    methodKind: "unary";
    input: typeof ListReleasesRequestSchema;
    output: typeof ListReleasesResponseSchema;
  },
  /**
   * GetLatestRelease returns the most recently published non-deprecated release
   * for the given group. Requires Auth0 JWT (standard UI auth).
   *
   * @generated from rpc releases.v1.ReleasesService.GetLatestRelease
   */
  getLatestRelease: {
    methodKind: "unary";
    input: typeof GetLatestReleaseRequestSchema;
    output: typeof GetLatestReleaseResponseSchema;
  },
  /**
   * GetReleaseByVersion looks up a single release by release_group + version.
   * Returns NOT_FOUND if no matching release exists.
   * Requires Auth0 JWT (standard UI auth).
   *
   * @generated from rpc releases.v1.ReleasesService.GetReleaseByVersion
   */
  getReleaseByVersion: {
    methodKind: "unary";
    input: typeof GetReleaseByVersionRequestSchema;
    output: typeof GetReleaseByVersionResponseSchema;
  },
  /**
   * GetReleaseByID looks up a single release by its typed ID.
   * Returns NOT_FOUND if the release does not exist.
   * Requires Auth0 JWT (standard UI auth).
   *
   * @generated from rpc releases.v1.ReleasesService.GetReleaseByID
   */
  getReleaseByID: {
    methodKind: "unary";
    input: typeof GetReleaseByIDRequestSchema;
    output: typeof GetReleaseByIDResponseSchema;
  },
  /**
   * DeprecateRelease marks a release as deprecated so it can no longer be
   * selected for new workspace installations. Fails with FAILED_PRECONDITION
   * if one or more workspaces still depend on this release (as
   * current_release_id, or as the target of an in-flight promote/upgrade) -
   * call CheckReleaseDeprecateBlockers first to check and display those
   * tenants before confirming.
   * Requires Auth0 JWT with operator_admin role.
   *
   * @generated from rpc releases.v1.ReleasesService.DeprecateRelease
   */
  deprecateRelease: {
    methodKind: "unary";
    input: typeof DeprecateReleaseRequestSchema;
    output: typeof DeprecateReleaseResponseSchema;
  },
  /**
   * CheckReleaseDeprecateBlockers returns the number of workspaces that
   * currently block deprecating this release. A count of 0 means deprecation
   * is allowed.
   * Requires Auth0 JWT with operator_admin role.
   *
   * @generated from rpc releases.v1.ReleasesService.CheckReleaseDeprecateBlockers
   */
  checkReleaseDeprecateBlockers: {
    methodKind: "unary";
    input: typeof CheckReleaseDeprecateBlockersRequestSchema;
    output: typeof CheckReleaseDeprecateBlockersResponseSchema;
  },
  /**
   * UpdateReleaseState toggles a release's enabled/disabled state. Disabled
   * releases are hidden from workspace create/upgrade dropdowns but remain
   * visible in the admin release list.
   * Requires Auth0 JWT with operator_admin role.
   *
   * @generated from rpc releases.v1.ReleasesService.UpdateReleaseState
   */
  updateReleaseState: {
    methodKind: "unary";
    input: typeof UpdateReleaseStateRequestSchema;
    output: typeof UpdateReleaseStateResponseSchema;
  },
  /**
   * SyncRelease dispatches a release-level manifest sync (weekly_release_sync.yml
   * against the release's own branch) and returns immediately with
   * sync_status IN_PROGRESS. On completion, releases.manifest_metadata/
   * sync_status/last_synced_at are refreshed. Has real side effects (a real
   * CI dispatch that can auto-merge a manifest PR), so - like
   * DeprecateRelease/UpdateReleaseState - this requires admin role or above,
   * not just any authenticated caller.
   * Requires Auth0 JWT with admin role or above.
   *
   * @generated from rpc releases.v1.ReleasesService.SyncRelease
   */
  syncRelease: {
    methodKind: "unary";
    input: typeof SyncReleaseRequestSchema;
    output: typeof SyncReleaseResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_releases_v1_releases, 0);

